import { render, staticRenderFns } from "./OtbnArgentina.vue?vue&type=template&id=4ee2560a&lang=pug"
import script from "./OtbnArgentina.vue?vue&type=script&lang=js"
export * from "./OtbnArgentina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports